import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { getAreas } from 'api/areas';
import { createAssistantArea } from 'api/assistants';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';
import Popup from 'components/Popup';

export default function AssistantAddAreasPopup({
    visible,
    setVisible,
    present = []
}) {

    const { assistantId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['createAssistantArea'],
        mutationFn: createAssistantArea,
        onSuccess: () => {
            cache.invalidateQueries(['assistants', assistantId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error creating assistant-area:", error);
        }
    });

    const { data: areas } = useQuery({
        queryKey: ['areas'],
        queryFn: async () => await getAreas({}),
    });


    const selectOptions = areas?.map(area => {
        return {
            value: area._id,
            label: area.name
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: assistantId,
            data: {
                area: e.target.area.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona area"
                        name="area"
                        options={selectOptions?.filter(element => !present?.includes(element.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
